export default "__VITE_ASSET__C$XY1km___"